module.exports = __webpack_public_path__ + "static/media/new_client_flow_sketch.ce8b9dc9.jpeg";